<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <v-card class="pr-3 pl-3 pb-3">
      <v-card-title class="headline pt-4">Let's Get Started</v-card-title>
      <v-card-text style="text-align: justify">
        We at CampusBox are trying to create a website used solely by the students of IITK. To make it possible we are
        authenticating the users through the IITK email. After this you will be send a mail through which you have to complete a small procedure.
      </v-card-text>
      <v-layout column ma-3>
        
        <v-text-field autofocus v-model="email" label="Email address" suffix="@iitk.ac.in" color="black"></v-text-field>
        
        <v-text-field v-model="firstname" label="First Name" color="black"></v-text-field>
        <v-text-field v-model="lastname" label="Last Name" color="black"></v-text-field>
        <v-text-field v-model="contact" label="Contact Number" color="black"></v-text-field>
        <v-layout row wrap>
        <span class="subheading mt-1 pt-2 grey--text text--darken-1 mr-1">Upload Display Picture</span><Upload @fileChosen="fileChosen" :maxSize="maxSize"></Upload>
        </v-layout>
        
        <v-text-field
          v-model="password"
          :append-icon="show1 ? 'visibility' : 'visibility_off'"
          :type="show1 ? 'text' : 'password'"
          name="input-10-1"
          label="Password"
          counter
          @keyup.enter="submit"
          @click:append="show1 = !show1"
          color="black"
          hint="Set up a new password"
        ></v-text-field>
      </v-layout>
      <v-card-actions>
        <v-btn color="green darken-1" flat="flat" @click="update">Back</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" flat="flat" @click="submit" :loading="loading">Submit</v-btn>
      </v-card-actions>
    </v-card>
  <v-snackbar
    v-model="snackbar"
    :color="color"
    :multi-line="mode === 'multi-line'"
    :timeout="timeout"
    :vertical="mode === 'vertical'"
  >{{ text }}</v-snackbar>
  </v-dialog>
</template>
<script>
import firebase from "firebase";
import Upload from "./Upload.vue";
export default {
  name: "Popup",
  components : {
    Upload,
  },
  data() {
    return {
      avatarFile : null,
      maxSize : 204800,
      snackbar: false,
      color: '',
      mode: '',
      timeout: 4000,
      text: '',
      firstname: "",
      lastname: "",
      email: "",
      contact: "",
      avatar: "https://firebasestorage.googleapis.com/v0/b/campusbox-e0794.appspot.com/o/blank-avatar.png?alt=media&token=de3cbe7c-9e6a-4e2f-9f91-212adb667df5", //Default avatar image location
      interested : [],
      accepted_buy : [],
      requested: [],
      accepted: [],
      rejected: [],
      loading: false,
      //Temporary Data
      password: "",
      show1: false,
      errorMessage: ""
    };
  },
  props: {
    dialog: Boolean
  },
  methods: {
    fileChosen(e){
      var vm = this;
      vm.avatarFile = e;
    },
    update: function(dialog) {
      this.$emit("change", dialog);
    },
    submit: function() {
      this.loading = true;
      var vm = this;
      var db=firebase.firestore();
      firebase
        .auth()
        .createUserWithEmailAndPassword(
          this.email + "@iitk.ac.in",
          this.password
        )
        .then(function() {
          var actionCodeSettings = {
            url: "http://campusbox-e0794.firebaseapp.com/login"
          };
          firebase
            .auth()
            .currentUser.sendEmailVerification(actionCodeSettings)
            .then(function() {
              if(vm.avatarFile){
                firebase.storage().ref().child('avatars/'+firebase.auth().currentUser.uid).put(vm.avatarFile).then(function (snapshot) {
                  snapshot.ref.getDownloadURL()
                  .then(function (downloadURL) {
                    vm.avatar = downloadURL;
                    db.collection("users").doc(firebase.auth().currentUser.uid).set({
                      name: vm.firstname+' '+vm.lastname,
                      email : firebase.auth().currentUser.email,
                      contact: vm.contact,
                      avatar: vm.avatar,
                      requested: vm.requested,
                      accepted: vm.accepted,
                      rejected: vm.rejected,
                      interested : vm.interested,
                      accepted_buy : vm.accepted_buy
                    }).then(function () {
                      firebase.auth().currentUser.updateProfile({
                        displayName : vm.firstname + ' ' + vm.lastname,
                        phoneNumber : Number(vm.contact),
                        photoURL : vm.avatar
                      }).then(function () {
                        firebase
                          .auth()
                          .signOut()
                          .then(function() {
                            vm.text=vm.firstname+", Verify your e-mail from the verification link sent to you and login.";
                            vm.color = "success";
                            vm.snackbar = true;
                            setTimeout(function () {
                              vm.$router.push("/login");
                            },3500);
                        });
                      }).catch(function (error) {
                        firebase.auth().currentUser.delete().then(function () {
                          vm.text = "Error Signing Up";
                          vm.color = "error";
                          vm.snackbar=true;
                          vm.loading=false;
                        });
                      })
                    }).catch(function (error) {
                      firebase
                        .auth()
                        .signOut()
                        .then(function() {
                          vm.$router.push("/login");
                      });
                    })
                  })
                })
              }
              else {
                db.collection("users").doc(firebase.auth().currentUser.uid).set({
                  name: vm.firstname+' '+vm.lastname,
                  email : firebase.auth().currentUser.email,
                  contact: vm.contact,
                  avatar: vm.avatar,
                  requested: vm.requested,
                  accepted: vm.accepted,
                  rejected: vm.rejected,
                  interested : vm.interested,
                  accepted_buy : vm.accepted_buy
                  
                }).then(function () {
                  firebase.auth().currentUser.updateProfile({
                    displayName : vm.firstname + ' ' + vm.lastname,
                    phoneNumber : vm.contact,
                    photoURL : vm.avatar
                  }).then(function () {
                    firebase
                      .auth()
                      .signOut()
                      .then(function() {
                        vm.text=vm.firstname+", Verify your e-mail from the verification link sent to you and login.";
                        vm.color = "success";
                        vm.snackbar = true;
                        setTimeout(function () {
                          vm.$router.push("/login");
                        },3500);
                    });
                  }).catch(function (error) {
                    firebase.auth().currentUser.delete().then(function () {
                      vm.loading=false;
                      vm.text = "Error Signing Up";
                      vm.color = "error";
                      vm.snackbar=true;
                    });
                  })
                }).catch(function (error) {
                  firebase
                    .auth()
                    .signOut()
                    .then(function() {
                      vm.$router.push("/login");
                  });
                })
              }
            })
            .catch(function(error) {
              vm.loading = false;
              //email Verification Error
              vm.text = "Error Signing Up";
              vm.color = "error";
              vm.snackbar = true;
            });
        })
        .catch(function(error) {
        vm.loading = false;
        vm.text="Error Signing Up.";
        vm.color="error";
        vm.snackbar=true;          
        });
    }
  }
};
</script>